// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inscriptions_modal_component .modal2__container {
    max-width: 700px;
}

.inscriptions_selected-team{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 24px;
}

.inscriptions_subtitle.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    margin-bottom: 24px;
}

.inscriptions_text{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--primary-very-dark-color);
    margin-bottom: 23px;
}

.inscriptions_team-data{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 16px 8px;
    width: 60%;
}

.inscriptions_team-data__image{
    display: flex;
    align-items: center;
    justify-content: center;
}

.inscriptions_team-data__image img{
    border-radius: 50%;
    width: 38px;
    height: 38px;
    margin-right: 10px;
}

.inscriptions_team-data__image .icon-ball{
    color: var(--white-color);
    font-size: 30px;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
}

.inscriptions_team-data__team.baloa-table-column{
    color: var(--primary-very-dark-color);
}
.inscriptions_team-data__teamname.baloa-username{
    color: var(--primary-dark-color);
}

.inscriptions_buttons{
    border-top: 1px solid var(--new-input-background-color);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 11px 18px;
}

.form.inscriptions_search-team{
    width: 80%
}

.inscriptions_payment{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 25px 0;
}

.inscriptions_payment .inscription-fee__container, .inscriptions_payment .inscription-fee-player__container{
    width: 80%
}

.inscriptions_payment-title{
    margin-left: var(--space-x3);
}

.inscription_team__button-create-team{
    margin: var(--space) 0px;
    width: 80%;
    display: flex;
    flex-direction: column;
    gap: var(--space);
    align-items: flex-start;
}

.inscription_team__button-create-team .baloa-table{
    color: var(--primary-very-dark-color);
}

.span-inscriptions_selected-team_loading{
    border: 3px solid var(--primary-very-light-color);
    border-top: 3px solid var(--basic-green-color);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 2s linear infinite;
    margin: auto;
    font-size: var(--font-small);
    font-weight: var(--font-bold);
    font-family: var(--primary-font);
    line-height: var(--space);
    letter-spacing: 0.04em;
    color: var(--primary-very-dark-color);
}

.span-inscriptions_selected-team_loading.button-inscription{
    width: 20px;
    height: 20px;
}

.inscriptions_search-team .tournament-team-player__input .MuiListItem-root{
    padding-top: 0;
    padding-bottom: 0;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .inscriptions_modal_component .modal2__container{
        height: 100%;
        margin: 0px;
        max-height: 100%;
        border-radius: 0px;
    }
    
    .inscriptions_modal_component .modal2__content{
        height: 100%;
    }

    .inscriptions_buttons{
        border-top: none;
        width: 100%;
        position: absolute;
        bottom: 0;
    }

    .inscriptions.scroll-parent .inscriptions_buttons .primary-button{
        width: 100%;
        padding: var(--space) 0;
        font-size: calc( var(--space) + var(--space-quarter) + 1px);
    }

    .inscriptions_selected-team{
        align-items: flex-start;
        margin: var(--space);
    }

    .inscriptions_payment-title{
        /* margin-left: 10%; */
        margin-left: 17px;
    }

    .inscriptions_modal_component .modal2__header__title.baloa-subtitle-2{
        font-size: calc(var(--space-and-half) + 2px);
    }

    .inscriptions_team-data {
        width: 100%;
    }

    .form.inscriptions_search-team{
        width: 100%
    }

    .inscription_team__button-create-team{
        margin: var(--space) 1rem;
    }

    .inscriptions_payment .inscription-fee__container, .inscriptions_payment .inscription-fee-player__container{
        padding: 0 16px;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/inscriptions-modal/InscriptionsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,uDAAuD;IACvD,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iDAAiD;IACjD,8CAA8C;IAC9C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,2DAA2D;IAC/D;;IAEA;QACI,uBAAuB;QACvB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,4CAA4C;IAChD;;IAEA;QACI,WAAW;IACf;;IAEA;QACI;IACJ;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;QACf,WAAW;IACf;AACJ","sourcesContent":[".inscriptions_modal_component .modal2__container {\n    max-width: 700px;\n}\n\n.inscriptions_selected-team{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 24px;\n}\n\n.inscriptions_subtitle.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    margin-bottom: 24px;\n}\n\n.inscriptions_text{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 19px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--primary-very-dark-color);\n    margin-bottom: 23px;\n}\n\n.inscriptions_team-data{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 16px 8px;\n    width: 60%;\n}\n\n.inscriptions_team-data__image{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.inscriptions_team-data__image img{\n    border-radius: 50%;\n    width: 38px;\n    height: 38px;\n    margin-right: 10px;\n}\n\n.inscriptions_team-data__image .icon-ball{\n    color: var(--white-color);\n    font-size: 30px;\n    padding: 4px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 10px;\n}\n\n.inscriptions_team-data__team.baloa-table-column{\n    color: var(--primary-very-dark-color);\n}\n.inscriptions_team-data__teamname.baloa-username{\n    color: var(--primary-dark-color);\n}\n\n.inscriptions_buttons{\n    border-top: 1px solid var(--new-input-background-color);\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 11px 18px;\n}\n\n.form.inscriptions_search-team{\n    width: 80%\n}\n\n.inscriptions_payment{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding: 25px 0;\n}\n\n.inscriptions_payment .inscription-fee__container, .inscriptions_payment .inscription-fee-player__container{\n    width: 80%\n}\n\n.inscriptions_payment-title{\n    margin-left: var(--space-x3);\n}\n\n.inscription_team__button-create-team{\n    margin: var(--space) 0px;\n    width: 80%;\n    display: flex;\n    flex-direction: column;\n    gap: var(--space);\n    align-items: flex-start;\n}\n\n.inscription_team__button-create-team .baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.span-inscriptions_selected-team_loading{\n    border: 3px solid var(--primary-very-light-color);\n    border-top: 3px solid var(--basic-green-color);\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 2s linear infinite;\n    margin: auto;\n    font-size: var(--font-small);\n    font-weight: var(--font-bold);\n    font-family: var(--primary-font);\n    line-height: var(--space);\n    letter-spacing: 0.04em;\n    color: var(--primary-very-dark-color);\n}\n\n.span-inscriptions_selected-team_loading.button-inscription{\n    width: 20px;\n    height: 20px;\n}\n\n.inscriptions_search-team .tournament-team-player__input .MuiListItem-root{\n    padding-top: 0;\n    padding-bottom: 0;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .inscriptions_modal_component .modal2__container{\n        height: 100%;\n        margin: 0px;\n        max-height: 100%;\n        border-radius: 0px;\n    }\n    \n    .inscriptions_modal_component .modal2__content{\n        height: 100%;\n    }\n\n    .inscriptions_buttons{\n        border-top: none;\n        width: 100%;\n        position: absolute;\n        bottom: 0;\n    }\n\n    .inscriptions.scroll-parent .inscriptions_buttons .primary-button{\n        width: 100%;\n        padding: var(--space) 0;\n        font-size: calc( var(--space) + var(--space-quarter) + 1px);\n    }\n\n    .inscriptions_selected-team{\n        align-items: flex-start;\n        margin: var(--space);\n    }\n\n    .inscriptions_payment-title{\n        /* margin-left: 10%; */\n        margin-left: 17px;\n    }\n\n    .inscriptions_modal_component .modal2__header__title.baloa-subtitle-2{\n        font-size: calc(var(--space-and-half) + 2px);\n    }\n\n    .inscriptions_team-data {\n        width: 100%;\n    }\n\n    .form.inscriptions_search-team{\n        width: 100%\n    }\n\n    .inscription_team__button-create-team{\n        margin: var(--space) 1rem;\n    }\n\n    .inscriptions_payment .inscription-fee__container, .inscriptions_payment .inscription-fee-player__container{\n        padding: 0 16px;\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
